// extracted by mini-css-extract-plugin
export default {"container":"lXjgWq","item":"TZ6_II","separator":"dczcyO","link":"s6R7Q6"};